import { createContext, useContext, type ReactNode } from "react";
import {
  factFinderConfig,
  type FactFinderConfig,
} from "@/config/fact-finder";

const FactFinderConfigContext = createContext<FactFinderConfig>(factFinderConfig);

interface FactFinderConfigProviderProps {
  children: ReactNode;
  config?: FactFinderConfig;
}

export function FactFinderConfigProvider({
  children,
  config = factFinderConfig,
}: FactFinderConfigProviderProps) {
  return (
    <FactFinderConfigContext.Provider value={config}>
      {children}
    </FactFinderConfigContext.Provider>
  );
}

export function useFactFinderConfig() {
  return useContext(FactFinderConfigContext);
}
